import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "hasError", "disabled", "isFullWidth", "endAdornment", "startAdornment", "extraDescription", "helperText", "isShownAsFocused", "selectedOption", "name", "className", "placeholder", "onSearchText", "showSearchInput"];
import React, { useEffect, useRef } from 'react';
import { SelectStyles } from "./Select.styles.js";
export var SelectField = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _selectedOption$selec;
  var label = _ref.label,
    hasError = _ref.hasError,
    disabled = _ref.disabled,
    isFullWidth = _ref.isFullWidth,
    endAdornment = _ref.endAdornment,
    startAdornment = _ref.startAdornment,
    extraDescription = _ref.extraDescription,
    helperText = _ref.helperText,
    isShownAsFocused = _ref.isShownAsFocused,
    selectedOption = _ref.selectedOption,
    name = _ref.name,
    className = _ref.className,
    placeholder = _ref.placeholder,
    onSearchText = _ref.onSearchText,
    showSearchInput = _ref.showSearchInput,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var searchInputId = useRef("select-field-search-input-".concat(Math.ceil(Math.random() * 10000)));
  useEffect(function () {
    if (!showSearchInput) {
      onSearchText('');
    }
  }, [showSearchInput]);
  return /*#__PURE__*/React.createElement(SelectStyles.Wrapper, {
    className: className,
    $isFullWidth: isFullWidth,
    "aria-disabled": disabled
  }, extraDescription ? /*#__PURE__*/React.createElement(SelectStyles.ExtraDescription, {
    "data-testid": "select-extra-description"
  }, extraDescription) : null, /*#__PURE__*/React.createElement(SelectStyles.InnerWrapper, _extends({
    as: "button",
    "aria-label": label,
    ref: ref,
    $hasError: hasError,
    $disabled: disabled,
    $placeholder: placeholder,
    $isShownAsFocused: isShownAsFocused,
    $isLabelShrunk: !!(selectedOption !== null && selectedOption !== void 0 && selectedOption.label) || !!isShownAsFocused,
    type: "button"
  }, otherProps), startAdornment ? /*#__PURE__*/React.createElement(SelectStyles.AdornmentWrapper, {
    "data-testid": "select-start-adornment"
  }, startAdornment) : null, /*#__PURE__*/React.createElement(SelectStyles.ValueWrapper, null, /*#__PURE__*/React.createElement(SelectStyles.LabelText, {
    "data-testid": "select-label-text",
    $hasError: hasError,
    $disabled: disabled
  }, label), !showSearchInput && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) && /*#__PURE__*/React.createElement(SelectStyles.SelectedOption, {
    $placeholder: placeholder,
    "data-testid": "selected-option-label"
  }, (_selectedOption$selec = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.selectedLabel) !== null && _selectedOption$selec !== void 0 ? _selectedOption$selec : selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label), showSearchInput && /*#__PURE__*/React.createElement(SelectStyles.SearchInputStyled, {
    type: "text",
    "aria-label": "search-input",
    id: searchInputId.current,
    onClick: function onClick(evt) {
      return evt.stopPropagation();
    },
    onKeyUp: function onKeyUp(evt) {
      return evt.preventDefault();
    },
    onChange: function onChange(evt) {
      return onSearchText(evt.target.value);
    },
    autoFocus: true
  })), endAdornment ? /*#__PURE__*/React.createElement(SelectStyles.AdornmentWrapper, null, endAdornment) : null), /*#__PURE__*/React.createElement(SelectStyles.AccessibleLabel, null, label, /*#__PURE__*/React.createElement(SelectStyles.HiddenInput, {
    "aria-invalid": hasError,
    "data-testid": "select-field-input",
    "aria-hidden": "true",
    tabIndex: -1,
    value: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) || '',
    name: name,
    disabled: disabled,
    onChange: function onChange() {
      return undefined;
    }
  })), helperText ? /*#__PURE__*/React.createElement(SelectStyles.HelperText, {
    "data-testid": "select-helper-text",
    $hasError: hasError
  }, helperText) : null);
});